module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('article', {
    staticClass: "article"
  }, [_c('p', {
    staticClass: "tc fwbd mt20"
  }, [_vm._v("个人信息使用授权书")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt20 txin"
  }, [_vm._v("重要提示:")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt20 txin"
  }, [_vm._v("为了保障您的合法权益，您应当阅读并遵守本授权书，请您务必审慎阅读、充分理 解本授权书条款内容，特别是免除或者减轻上海华瑞银行股份有限公司(以下简称为“被授权人” )责任，或限制您权利的条款，其中免除或者减轻责任条款已经以加粗形式提示您注意。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt20 txin"
  }, [_vm._v("除非您已阅读并同意本授权书所有条款，否则您无权使用“华瑞银行·众安保险场景贷业务”(即被授权 人与众安在线财产保险股份有限公司合作项下的消费类贷款信用保险服务产品，产品清单详细见附 件，以下简称“场景贷”)相关产品服务。您的登录、使用等行为即视为您已阅读并同意接受本授 权书条款的约束。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20"
  }, [_vm._v("上海华瑞银行股份有限公司:")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("本人充分理解并同意，“场景贷”服务是上海华瑞 银行股份有限公司(以下简称“华瑞银行”)与众安在线财产保险股份有限公司合作为本人提供的 贷款信用保险服务产品，现本人主动申请开通此项服务，为客观、准确地评估本人的信用等级和授 信额度，并为本人提供优质地服务，就使用本人的相关必要信息，本人同意并授权如下。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("一、本人 同意并授权，"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("华瑞银行可使用和分析本人在华瑞银行中的相关历史信息、支付数据信息;")])]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("二、本人 同意并授权，"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("为便于华瑞银行给本人发放贷款，华瑞银行可以将本人的姓名、身份证号、联系方式 、银行卡信息及其他相关必要信息传输给第三方机构查询本人相关信息;")])]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("三、本人同意并授权，"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("在 本人逾期还款时，华瑞银行通可将本人的其他联系方式和联系地址等信息传输给华瑞银行合作的催 收机构作催收贷款所用;")])]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("四、本人同意并授权，"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("华瑞银行仅将以上信息作本贷款分析所用，将严格 保护本人的隐私，同时并未违反华瑞银行与本人之间的相关保密义务，且华瑞银行应免予承担任何 违约责任或赔偿责任;")])]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin fwbd"
  }, [_vm._v("五、本人授权华瑞银行查询的信息、本人享受华瑞银行服务产生的信息，为 便于向本人提供更加优质的服务和产品，本人授权华瑞银行可以将前述信息分享给必要的合作伙伴。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20"
  }, [_vm._v("授权人声明:")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin fwbd"
  }, [_vm._v("本授权书是本人向上海华瑞银行股份有限公司做出的单方承诺，效力具有独立性 ，不因场景贷《借款合同》的任何条款无效而失效。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("以上授权期限为本人作出本授权承诺之日起至 本人在贷款人处所有业务终结之日止。"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("本人在贷款人处有借款额度但无借款余额的情况下，本人与\n        贷款人的业务关系仍然存续，贷款人仍有权向中国人民银行金融信用信息基础数据库查询、上报本\n        人的信用信息。")])]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin fwbd"
  }, [_vm._v("若本人与被授权人发生任何纠纷或争议，首先应友好协商解决;协商不成的，本人\n        同意将纠纷或争议提交本授权书签订地(即中国上海市浦东新区)有管辖权的人民法院管辖。本授\n        权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律(不包括冲突法)\n        。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin fwbd"
  }, [_vm._v("本人已知悉本授权书所有内容(特别是加粗字体内容)的意义以及由此产生的法律效力，自愿作\n        出上述授权，本授权书是本人真实的意思表示，本人同意承担由此带来的一切法律后果。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("特此授权!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10fc9d36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/perauthorize.vue
// module id = 190
// module chunks = 0